import React from "react";

// Safe fallbacks for animations
const safeUseReveal = () => {
  try {
    // @ts-ignore
    if (typeof useReveal === "function") return useReveal();
  } catch (e) {}
  return null;
};

const safeHide = (direction) => {
  try {
    // @ts-ignore
    if (typeof hide === "function") return hide(direction);
  } catch (e) {}
  return {};
};

const SERVICES = [
  {
    id: "01",
    title: "Trade Facilitation",
    desc: "Support for import-export activities, trade documentation, logistics, and market access.",
    items: [
      "Import/export guidance",
      "Customs support",
      "Logistics assistance",
      "Market access",
    ],
  },
  {
    id: "02",
    title: "Business Networking",
    desc: "Connecting businesses, investors, institutions, and industry stakeholders.",
    items: [
      "Business forums",
      "Trade missions",
      "Networking events",
      "Partnership opportunities",
    ],
  },
  {
    id: "03",
    title: "Investment Support",
    desc: "Helping companies establish and expand operations between Bangladesh and Italy.",
    items: [
      "Market intelligence",
      "Investment advice",
      "Partner matching",
      "Business development",
    ],
  },
  {
    id: "04",
    title: "Policy & Institutional Engagement",
    desc: "Encouraging collaboration between public and private sectors.",
    items: [
      "Policy updates",
      "Strategic insights",
      "Stakeholder engagement",
      "Business advocacy",
    ],
  },
  {
    id: "05",
    title: "Legal & Compliance Assistance",
    desc: "Access to trusted professionals for legal, tax, and compliance support.",
    items: [
      "Company registration",
      "Licensing support",
      "Regulatory guidance",
      "Due diligence",
    ],
  },
];

export const ServicesPage = () => {
  const ref = safeUseReveal();

  return (
    <div className="w-full flex flex-col font-sans">
      {/* 1. HERO SECTION */}
      <section className="bg-[#0F1C35] pt-32 pb-24 lg:pt-40 lg:pb-32 relative overflow-hidden">
        {/* Decorative Background Element */}
        <div className="absolute top-0 right-0 w-1/2 h-full bg-[#C9952A]/5 skew-x-12 translate-x-20 pointer-events-none" />
        
        <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
          <div className="max-w-3xl mx-auto text-center flex flex-col items-center">
            
            <h1
              data-r
              className="text-5xl md:text-5xl lg:text-6xl font-black text-[#0077b6] leading-tight tracking-tight"
              style={safeHide("up")}
            >
              Services We Provide
            </h1>
            
            <p
              data-r
              className="mt-6 text-lg text-gray-300 font-light leading-relaxed"
              style={safeHide("up")}
            >
              Comprehensive support for businesses at every stage of their bilateral trade and investment journey, assistance to business operators, promotion of commercial, cultural and educational activities.
            </p>
          </div>
        </div>
      </section>

      {/* 2. SERVICES GRID SECTION */}
      <section ref={ref} className="bg-[#F8F9FA] py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {SERVICES.map((service) => (
              <div
                key={service.id}
                data-r
                style={safeHide("up")}
                className="group bg-white rounded-2xl border border-gray-200 p-8 hover:shadow-xl hover:border-gray-300 transition-all duration-300 flex flex-col h-full"
              >
                {/* Number Badge */}
                

                {/* Content */}
                <h3 className="text-2xl font-bold text-[#0F1C35] mb-4 group-hover:text-[#0077b6] transition-colors duration-300">
                  {service.title}
                </h3>

                <p className="text-gray-800 text-base leading-relaxed mb-3 flex-grow">
                  {service.desc}
                </p>

                {/* Features List */}
                <ul className="space-y-2 border-t border-gray-200 pt-4 mt-auto">
                  {service.items.map((item, index) => (
                    <li
                      key={index}
                      className="flex items-center gap-3 text-md tracking-wide font-medium text-gray-800"
                    >
                      <span className="w-1.5 h-1.5 rounded-full bg-[#0077b6] opacity-80" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;